var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 128,
    height: 128,
    rx: 64,
    fill: "#E9EEFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.999 27.734C54.2349 27.734 46.2969 35.6804 46.2969 45.4548C46.2969 55.0427 53.7877 62.8025 63.5518 63.1383C63.8499 63.101 64.1481 63.101 64.3717 63.1383C64.4462 63.1383 64.4835 63.1383 64.558 63.1383C64.5953 63.1383 64.5953 63.1383 64.6326 63.1383C74.1731 62.8025 81.6639 55.0427 81.7011 45.4548C81.7011 35.6804 73.7631 27.734 63.999 27.734Z",
    fill: "#0152A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4794 73.7219C71.9561 66.8729 54.7946 66.8729 44.196 73.7219C39.4059 76.8518 36.7656 81.0864 36.7656 85.6156C36.7656 90.1448 39.4059 94.3426 44.1583 97.4357C49.4387 100.897 56.3788 102.628 63.3188 102.628C70.2589 102.628 77.1989 100.897 82.4794 97.4357C87.2318 94.3057 89.872 90.108 89.872 85.542C89.8343 81.0128 87.2318 76.815 82.4794 73.7219Z",
    fill: "#0152A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserImg);
export default __webpack_public_path__ + "static/media/user-img.e562b0f146761418597f509e7374ab28.svg";
export { ForwardRef as ReactComponent };